<section>
    <h1 class="header">{{ pageData.header }}</h1>
    <div class="overage-block">
        <h2 class="ineligible-header">{{ pageData.subheader }}</h2>
        <div class="logo-block">
            <xm-media-image class="logo" [imageOptions]="overageIcon" size="height"></xm-media-image>
            <p class="description">{{ description }}</p>
            <cms-text [originalText]="pageData.cta"></cms-text>
        </div>
    </div>
</section>
